import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class AllocationTask {

  @JsonProperty()
  id: string;
  @JsonProperty()
  creationDate: DateTime = DateTime.now();
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  state: AllocationTask.STATE;
  @JsonProperty()
  message: string;
  @JsonProperty()
  exchangeCode: string;
  @JsonProperty()
  ccOperator: string;
  @JsonProperty()
  type: string;
  @JsonProperty()
  itemCount: number;
  @JsonProperty()
  allocationParametersJson: string;

}

export module AllocationTask {
  export enum STATE {
    IN_PROGRESS = "IN_PROGRESS",
    TREATED = "TREATED",
    ERROR = "ERROR",
  }
}

